/* Nach dem Absenden eines Newsletter-Formulars lädt Shopify die Seite mit #contact_form neu.
   Der Browser springt dann zum ersten Formular, und der mitlaufende Header verdeckt es.
   Wir merken uns, welches Formular abgeschickt wurde, und zeigen genau dieses vollständig. */
(function () {
  if (window.__fcSignup) return;
  window.__fcSignup = true;
  var KEY = 'fc-signup-from';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.email-signup__form');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    try { sessionStorage.setItem(KEY, input ? input.id : ''); } catch (err) {}
  }, true);

  var posted = /[?&]customer_posted=true/.test(location.search) || location.hash === '#contact_form';
  if (!posted) return;

  var id = null;
  try { id = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (err) {}

  function headerOffset() {
    var h = document.querySelector('.header-section, header-component, #header-group, .header');
    var r = h ? h.getBoundingClientRect() : null;
    return r && r.bottom > 0 ? Math.round(r.bottom) : 0;
  }

  /* Je nach Seite scrollt das Fenster oder ein innerer Bereich (.page-wrapper). */
  function scroller(el) {
    for (var n = el && el.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return document.scrollingElement || document.documentElement;
  }

  function scrollToY(box, y) {
    y = Math.max(0, Math.round(y));
    if (box === document.scrollingElement || box === document.documentElement) window.scrollTo(0, y);
    else box.scrollTop = y;
  }

  function fix() {
    var input = id ? document.getElementById(id) : null;
    var target = input ? (input.closest('.email-signup-block') || input.closest('form')) : null;
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);

    var first = document.querySelector('main .shopify-section');
    var anchor = target || first;
    if (!anchor) return;
    var box = scroller(anchor);
    if (!target || (first && first.contains(target))) {
      scrollToY(box, 0);
      window.scrollTo(0, 0);
      return;
    }
    target.scrollIntoView({ block: 'center' });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', function () { setTimeout(fix, 0); }, { once: true });
})();
